import React from "react";
import "../Css/style.css";
function ButtonForm(Props) {
  const { buttonText, color, onclick } = Props;
  return (
    <div className="full-width input-container">
      <button
        onClick={onclick}
        className={`full-width  border-none outline-none  ${color} `}
      >
        {buttonText}
      </button>
    </div>
  );
}

export default ButtonForm;
